export enum BusType {
  ROUNDTRIP = 'ROUNDTRIP',
  ONEWAY = 'ONEWAY'
}
